import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

export const PRDetailTableHead2 = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_150,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Patient ID',
    field: 'patientId',
    editable: false,
    sortable: true,
    filter: true,
    resizable: true,
    sort: 'asc',
    wrapHeaderText: true,
    dataAlignRight: true,
    autoHeaderHeight: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_20,
    cellClass: 'ag-cell-action',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Patient Name',
    field: 'firstName',
    editable: false,
    sortable: true,
    enableMenu: false,
    columnSpan: 3,
    resizable: true,
    minWidth: Styles.Width_240,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'ag-cell-action frr-overflow-visible',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Category',
    field: 'claimCategoryCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_160,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prescription Number',
    field: 'prescriptionNum',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    dataAlignRight: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_160,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      'white-space': 'normal',
      textAlign: 'right',
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Number Of Units',
    field: 'origNumOfUnits',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    dataAlignRight: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'CorrectionAmtCellRender1',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Number Of Units',
    field: 'numOfUnits',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    dataAlignRight: true,
    cellRenderer: 'CorrectionAmtCellRender2',

    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Problem code',
    field: 'problemCd',
    editable: false,
    sortable: false,
    filter: false,
    minWidth: Styles.Width_250,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ProblemCellRenderer',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Correction code',
    field: 'correctionCd',
    cellEditor: MaxLengthNumericEditor,
    editable: false,
    sortable: false,
    filter: false,
    minWidth: Styles.Width_240,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'CorrectionCellRenderer',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Supplied Days',
    field: 'suppliedDays',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_138,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    dataAlignRight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Service Date',
    field: 'serviceDt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Paid Date',
    field: 'paidDt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_171,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Submitted Amount',
    field: 'submittedAmt',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer: 'CorrectionAmtCellRender3',
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Allowed Amount',
    field: 'allowedAmt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_138,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer: 'CorrectionAmtCellRender4',
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'TPL/Copay',
    field: 'tplAmt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_160,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    dataAlignRight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Reimbursed Amount',
    field: 'reimbursementAmt',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer: 'CorrectionAmtCellRender5',
    minWidth: Styles.Width_171,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
];
